import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";
import React from "react";
import { ReactNode } from "react";

interface MProps extends ModalProps {
  hideCloseBtn?: boolean;
  closeBtnBgColor?: string;
  closeBtnColor?: string;
  title?: string;
  footer?: ReactNode;
  children: ReactNode;
  contentProps?: ModalContentProps;
}

const ModalContainer = ({
  hideCloseBtn = false,
  title,
  footer,
  children,
  contentProps,
  closeBtnBgColor,
  closeBtnColor,
  ...r
}: MProps) => {
  return (
    <Modal {...r}>
      <ModalOverlay />
      <ModalContent {...contentProps} bg={"whiteAlpha.200"}>
        {title && <ModalHeader>{title}</ModalHeader>}
        {!hideCloseBtn && (
          <ModalCloseButton
            bgColor={closeBtnBgColor ?? "transparent"}
            color={closeBtnColor ?? "white"}
            border="1px solid #000000"
          />
        )}
        <ModalBody padding="0px">{children}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
};

export default ModalContainer;
